import React from 'react';
import { Box, Typography } from '@mui/material';

const PrivacyPolicy = () => {
    return (
        <>
            <Box sx={{ padding: '24px', maxWidth: '800px', margin: '0 auto' }}>
                <Typography variant="h5" gutterBottom sx={{ paddingTop: '16px', paddingBottom: '8px' }}>
                    Instapath Privacy Policy
                </Typography>
                <Typography variant="body2" sx={{ marginBottom: 4, color: '#6c757d' }}>
                    Last Updated: December 22, 2024
                </Typography>

                <Typography variant="body1" component="p" gutterBottom>
                    Instapath.io is a website owned and operated by Rigg Dynamics LLC.
                </Typography>

                <Typography variant="body1" component="p" gutterBottom>
                    Rigg Dynamics LLC (“Rigg Dynamics”, “we”, “us”, or “our”) is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and share your personal information when you use our applications (the “Apps”).
                </Typography>

                <Typography variant="body1" component="p" gutterBottom>
                    By using our Apps, you agree to the terms of this Privacy Policy. If you do not agree with our policies and practices, please do not use our Apps.
                </Typography>

                <Typography variant="h5" gutterBottom sx={{ paddingTop: '16px', paddingBottom: '8px' }}>
                    Information We Collect
                </Typography>
                <Typography variant="body1" component="p" gutterBottom>
                    We may collect the following types of information when you use our Apps:
                </Typography>
                <ul style={{ margin: 0, paddingLeft: '16px' }}>
                    <li>
                        <strong>Personal Information:</strong> This includes information that can identify you, such as your name and email address (if you choose to provide it).
                    </li>
                    <li>
                        <strong>Usage Data:</strong> This includes information about how you interact with our Apps, such as the features you use, the pages you visit, and the time and duration of your sessions.
                    </li>
                    <li>
                        <strong>Device Information:</strong> This includes information about your device, such as the device type, operating system, unique device identifiers, and network information.
                    </li>
                </ul>

                <Typography variant="h5" gutterBottom sx={{ paddingTop: '16px', paddingBottom: '8px' }}>
                    How We Use Your Information
                </Typography>
                <Typography variant="body1" component="p" gutterBottom>
                    We may use your information for the following purposes:
                </Typography>
                <ul style={{ margin: 0, paddingLeft: '16px' }}>
                    <li>To Provide and Improve Our Apps: We use your information to deliver, maintain, and improve our Apps, develop new features, and personalize your experience.</li>
                    <li>To Communicate with You: We may use your information to send you notifications, updates, and promotional materials related to our Apps. You can opt out of these communications at any time.</li>
                    <li>To Analyze and Understand User Behavior: We use aggregated, anonymized data to analyze trends, track user behavior, and improve our Apps.</li>
                    <li>To Comply with Legal Obligations: We may process your information to comply with applicable laws, regulations, or legal processes.</li>
                </ul>

                <Typography variant="h5" gutterBottom sx={{ paddingTop: '16px', paddingBottom: '8px' }}>
                    How We Share Your Information
                </Typography>
                <Typography variant="body1" component="p" gutterBottom>
                    We may share your information with the following third parties:
                </Typography>
                <ul style={{ margin: 0, paddingLeft: '16px' }}>
                    <li>
                        <strong>Service Providers:</strong> We may share your information with third-party service providers who help us operate and maintain our Apps.
                    </li>
                    <li>
                        <strong>Business Partners:</strong> We may share your information with business partners who offer products or services that we believe may be of interest to you.
                    </li>
                    <li>
                        <strong>Legal Authorities:</strong> We may share your information with law enforcement or other government agencies as required by law or to protect our rights or safety.
                    </li>
                </ul>
                <Typography variant="h5" gutterBottom sx={{ paddingTop: '16px', paddingBottom: '8px' }}>
                    Security of Your Information
                </Typography>
                <Typography variant="body1" component="p" gutterBottom>
                    We take reasonable measures to protect your information from unauthorized access, disclosure, alteration, or destruction. However, no method of transmission over the Internet or electronic storage is 100% secure. Therefore, we cannot guarantee its absolute security.
                </Typography>

                <Typography variant="h5" gutterBottom sx={{ paddingTop: '16px', paddingBottom: '8px' }}>
                    Your Choices
                </Typography>
                <Typography variant="body1" component="p" gutterBottom>
                    You have the following choices regarding your information:
                </Typography>
                <ul style={{ margin: 0, paddingLeft: '16px' }}>
                    <li>
                        <strong>Access and Update:</strong> You may review, correct, or update your personal information by contacting us.
                    </li>
                    <li>
                        <strong>Opt-Out:</strong> You can opt out of receiving promotional emails by following the unsubscribe instructions in the emails.
                    </li>
                </ul>
                <Typography variant="h5" gutterBottom sx={{ paddingTop: '16px', paddingBottom: '8px' }}>
                    Children’s Privacy
                </Typography>
                <Typography variant="body1" component="p" gutterBottom>
                    Our Apps are not intended for children under the age of 13. We do not knowingly collect or solicit personal information from children. If you are a parent or guardian and believe that your child has provided us with personal information, please contact us here, and we will take steps to delete such information.
                </Typography>

                <Typography variant="h5" gutterBottom sx={{ paddingTop: '16px', paddingBottom: '8px' }}>
                    Changes to This Privacy Policy
                </Typography>
                <Typography variant="body1" component="p" gutterBottom>
                    We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.
                </Typography>

                <Typography variant="h5" gutterBottom sx={{ paddingTop: '16px', paddingBottom: '8px' }}>
                    Contact Us
                </Typography>
                <Typography variant="body1" component="p" gutterBottom>
                    If you have any questions about this Privacy Policy, please contact us.
                </Typography>

                <Typography variant="body2" align="center" sx={{ marginTop: 4, color: '#6c757d' }}>
                    Effective Date: December 22, 2024
                </Typography>
            </Box>
        </>
    );
};

export default PrivacyPolicy;